import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const AVAILABLE_EXTERNAL_FIELDS_QUERY_KEY = 'integrations-available-external-fields';

export function useGetAvailableExternalFieldsQuery({
	integrationProvider,
	objectType = 'Contact',
	impersonationContext,
	enabled = true,
}: {
	integrationProvider: Api.IntegrationProvider;
	objectType?: string | null;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () => {
			const queryParams = objectType ? `?objectType=${objectType}` : '';
			return userSession.webServiceHelper.callAsync<Api.IExternalField[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/availableFields/external${queryParams}`,
				}),
				'GET'
			);
		},
		queryKey: [AVAILABLE_EXTERNAL_FIELDS_QUERY_KEY, integrationProvider, objectType, impersonationContext],
	});
}

export const invalidateAvailableExternalFieldsQuery = ({
	impersonationContext,
}: {
	impersonationContext: Api.IImpersonationContext;
}) => reactQueryClient.invalidateQueries({ queryKey: [AVAILABLE_EXTERNAL_FIELDS_QUERY_KEY, impersonationContext] });
